import { Car } from "lucide-react";

const CITY_COORDS = {
  Abidjan: [5.345317, -4.024429], Bouake: [7.69, -5.03], Yamoussoukro: [6.827623, -5.289343],
  "San Pedro": [4.74859, -6.63633], Korhogo: [9.45821, -5.62973], Grand_Bassam: [5.2118, -3.7388], Assinie: [5.1333, -3.2833],
};

export const yangoLink = (hotel) => {
  const lat = hotel?.lat ?? CITY_COORDS[(hotel?.city || "").replace(/-/g, "_")]?.[0] ?? CITY_COORDS[hotel?.city]?.[0];
  const lon = hotel?.lon ?? CITY_COORDS[(hotel?.city || "").replace(/-/g, "_")]?.[1] ?? CITY_COORDS[hotel?.city]?.[1];
  if (lat == null || lon == null) return "https://yango.com/fr_ci/";
  return `https://yango.go.link/route?end-lat=${lat}&end-lon=${lon}&ref=fodindin&adj_t=vokme8e`;
};

export const YangoRideButton = ({ hotel, compact = false }) => {
  if (!hotel) return null;
  return (
    <a
      href={yangoLink(hotel)}
      target="_blank"
      rel="noreferrer"
      className={`inline-flex items-center justify-center gap-2 font-bold rounded-full transition-colors bg-[#fce000] text-black hover:bg-[#f5d800] ${compact ? "px-3 py-2 text-sm" : "px-4 py-3 w-full"}`}
      data-testid="yango-ride-btn"
    >
      <Car size={16} /> Commander un Yango vers l&apos;hotel
    </a>
  );
};
